import { produce } from 'immer';
import { entity } from 'simpler-state';

const INITIAL_STATE = { isConnected: false, isLoggedin: false, isConnectionTimedOut: false };

const self = entity(INITIAL_STATE);

const setConnected = (value: boolean): void => {
  self.set(
    produce(state => {
      state.isConnected = value;
    }),
  );
};

const setLoggedin = (value: boolean): void => {
  self.set(
    produce(state => {
      state.isLoggedin = value;
    }),
  );
};

const setConnectionTimedOut = (value: boolean): void => {
  self.set(
    produce(state => {
      state.isConnectionTimedOut = value;
    }),
  );
};

const setAll = (value: Partial<typeof INITIAL_STATE>): void => {
  self.set(
    produce(state => {
      if (value.isLoggedin != null) state.isLoggedin = value.isLoggedin;
      if (value.isConnected != null) state.isConnected = value.isConnected;
      if (value.isConnectionTimedOut != null) state.isConnectionTimedOut = value.isConnectionTimedOut;
    }),
  );
};

export default {
  use: () => self.use(data => data),
  useConnected: () => self.use(data => data.isConnected),
  useLoggedin: () => self.use(data => data.isLoggedin),
  useConnectionTimedOut: () => self.use(data => data.isConnectionTimedOut),
  isConnected: () => self.get().isConnected,
  isLoggedin: () => self.get().isLoggedin,
  isConnectionTimedOut: () => self.get().isConnectionTimedOut,
  setConnected,
  setLoggedin,
  setConnectionTimedOut,
  setAll,
};
